import React from "react";
import {
  Home,
  Announcement,
  Announcements,
  Branches,
  AboutUs,
  Contact,
  CardApplication,
  Category,
  PersonalCredit,
  Post,
  Page,
  Bulten,
  SubCategories,
  MoneyGram,
  Bultens,
  SearchResult,
  Uban
} from "./Pages";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Header, CommercialBanner, Menu, Footer, Loader } from "./Components";
import get_config from "actions/get_config";
import update_screen from "actions/update_screen";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { baseUrl } from "env";
import axios from "axios";
axios.defaults.baseURL = baseUrl;
class Routes extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  async componentDidMount() {
    await this.props.get_config();
  }
  resize() {
    switch (true) {
      case window.innerWidth > 1100:
        this.props.update_screen({
          mq: "l"
        });
        break;
      case window.innerWidth > 780 && window.innerWidth <= 1100:
        this.props.update_screen({
          mq: "m"
        });
        break;
      case window.innerWidth > 480 && window.innerWidth <= 780:
        this.props.update_screen({
          mq: "s"
        });
        break;
      default:
        this.props.update_screen({
          mq: "xs"
        });
    }
  }
  render = () => (
    <Router>
      <Loader>
        <CommercialBanner />
        <Header />
        <Menu {...this.props} />
        <Switch>
          <Route exact={true} path="/" component={Home} />
          <Route
            exact={true}
            path="/personal-credit"
            component={PersonalCredit}
          />
          <Route exact={true} path="/announcements" component={Announcements} />
          <Route exact={true} path="/hakkimızda" component={AboutUs} />
          <Route exact={true} path="/contact-us" component={Contact} />
          <Route
            exact={true}
            path="/card_application"
            component={CardApplication}
          />
          <Route exact={true} path="/uban" component={Uban} />
          <Route exact={true} path="/branches" component={Branches} />
          <Route exact={true} path="/post/:id" component={Post} />
          <Route exact={true} path="/pages/:url" component={Page} />
          <Route
            exact={true}
            path="/announcement/:id"
            component={Announcement}
          />
          <Route exact={true} path="/money_gram" component={MoneyGram} />
          <Route exact={true} path="/bultens" component={Bultens} />
          <Route exact={true} path="/bultens/:id" component={Bulten} />
          <Route path="/ara" component={SearchResult} />
          <Route path="/:category/:sub_category" component={SubCategories} />
          <Route path="/:category" component={Category} />
        </Switch>
        <Footer />
      </Loader>
    </Router>
  );
}
const mapStateToProps = state => ({
  config: state.config ? state.config.data : {},
  screen: state.screen
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      get_config,
      update_screen
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Routes);
